import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

const refundLaterApi = createAsyncThunk('refundLaterApi', async (body:any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = BILLING_ROUTES.INVOICE.refundLater;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error('Failed to fetch package details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });

export default refundLaterApi;
